import styled, { css } from "styled-components";
import { Link as RouterLink } from "react-router";

const LinkStyles = css`
  color: ${({ theme }) => theme.colors.white};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const Hyperlink = styled.a`
  ${LinkStyles}
`;

const Link = styled(RouterLink)`
  ${LinkStyles}
`;

export default Link;
